module.exports = __webpack_public_path__ + "static/media/t-shirt_1366.111d42a2.jpg";